// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.col-message[data-v-634fe0b0] {\n  max-width: 400px;\n  word-wrap: break-word;\n}\n", ""]);
// Exports
module.exports = exports;
